import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../../components/FormikControl/FormikControl';
import { Add, Edit } from '@mui/icons-material';
import { useAlert } from '../../../../context/AlertContext';
import userServices from '../userServices';
import { useAppData } from '../../../../context/AppDataContext';
import SelectEmployee from '../../erp/employee/components/SelectEmployee';


function UserForm({data,refreshList}) {

    const {AppAlert} = useAlert();
    const {userRoleDD,employeeDD,companyLocationDD} = useAppData();
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);
    const [changePassword, setChangePassword] = useState(false);

    const [employee,setEmployee] = useState(null);



    const initialValues = {
        email:"",
        password:"",
        firstName:"",
        lastName:"",
        role:"",
        employeeId:"",
        projectLocation:"",
    }

    const validationRule = Yup.object({
        email:Yup.string().required("Required"),
        firstName:Yup.string().required("Required"),
        employeeId:Yup.string().required("Required"),
        role:Yup.string().required("Required"),
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setChangePassword(true);
        setDialogStatus(true)
    }

    const updateData = ()=>{
        setChangePassword(false);
        let autoFill = {
            id:data.id,
            email:data.email,
            password:"",
            firstName:data.firstName,
            lastName:data.lastName,
            employeeId:data.employeeId,
            role:data.role,
            projectLocation:data.projectLocation,
        }
        console.log(autoFill);
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = (values, onSubmitProps) => {
        values.changePassword = changePassword;
        console.log(values);

        if(values.projectLocation == ""){
            delete values['projectLocation'];
        }
        
        userServices.save(values).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            refreshList()
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }



    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-primary" onClick={addNew} ><Add/> Add New</button>
                </Tooltip>
            }
            {data &&
                <Tooltip title="Update">
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
                aria-describedby="alert-dialog-slide-description"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogTitle>{"User Form"}</DialogTitle>
                                    <DialogContent>
                                        <div className="row p-2">
                                            
                                            <div className="col-md-12">

                                                <div className="row">
                                                    

                                                    {!data &&
                                                    <div className="col-md-12 p-2">
                                                        <label className="form-label fw-bold">Employee Association</label>
                                                        <SelectEmployee 
                                                            //employee={formik.values.employeeId} // Optional local object state if tracking full details
                                                            employee={employee}
                                                            setEmployee={(emp) => {
                                                                if (emp) {
                                                                    formik.setFieldValue('employeeId', emp.id);
                                                                    formik.setFieldValue('firstName', emp.employeeName || '');
                                                                    formik.setFieldValue('email', emp.email || '');
                                                                } else {
                                                                    formik.setFieldValue('employeeId', '');
                                                                    formik.setFieldValue('firstName', '');
                                                                    formik.setFieldValue('email', '');
                                                                }
                                                                console.log(emp);
                                                                setEmployee(emp)
                                                            }}
                                                            //employeeId={formik.values.employeeId}
                                                        />
                                                    </div>
                                                    }

                                                    {/*
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="First Name" name="firstName" 
                                                        className="col-md-6 col-xs-12 p-2" 
                                                    />

                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Last Name" name="lastName" 
                                                        className="col-md-6 col-xs-12 p-2" 
                                                    />
                                                    
                                                    */}

                                                    <div className='col-md-3 my-2'>
                                                        <FormikControl control="input" formik={formik} type="text" 
                                                            label="Login Email" name="email" 
                                                        />
                                                    </div>
                                                    


                                                    {/* Replace the old Autocomplete employeeId FormikControl with SelectEmployee */}
                                                    
                                                    {/*
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="Employee Id" name="employeeId"  
                                                        options={employeeDD} multiple={false} 
                                                        className="col-md-3 col-xs-6 p-2"
                                                    />
                                                    */}
    

                                                    
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="Role" name="role"  
                                                        options={userRoleDD} multiple={false} 
                                                        className="col-md-3 col-xs-6 p-2"
                                                    />


                                                    <div className='col-md-3 my-2'>
                                                        <FormikControl control="autoselect" formik={formik} 
                                                            label="Project Location" name="projectLocation"  
                                                            options={companyLocationDD} multiple={false} 
                                                        />
                                                    </div>
                                                    

                                                    {!changePassword &&  <button type="button" className="btn btn-link" onClick={()=>setChangePassword(true)} >Change Password </button> }
                                                    {changePassword &&
                                                        <FormikControl control="input" formik={formik} type="text" 
                                                            label="Password" name="password" 
                                                            className="col-md-6 col-xs-12 p-2" 
                                                        />
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                        { /*  JSON.stringify(formik.values) */}
                                        </div>

                                        {savingInProgress && <div className="row"><LinearProgress/></div> }
                                    </DialogContent>
                                    <DialogActions>
                                        
                                        
                                        {!savingInProgress && 
                                            <>
                                            <button className="btn btn-success" type="submit">Save</button>
                                            <button className="btn btn-danger" type="button" onClick={handleClose}>Cancel</button>
                                            </>
                                        }
                                        
                                    </DialogActions>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}

export default UserForm